import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Seo } from "@/components/Seo";

const inputCls =
  "w-full rounded-sm border border-border bg-white px-3 py-2.5 text-sm outline-none transition-colors focus:border-indigo focus:ring-1 focus:ring-indigo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) {
    navigate("/admin", { replace: true });
    return null;
  }

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4" data-testid="admin-login-page">
      <Seo title="Admin Login — Shineni India" description="Secure admin login for Shineni India." />
      <form onSubmit={submit} className="w-full max-w-sm border border-border bg-white p-8" data-testid="admin-login-form">
        <div className="flex items-baseline gap-2">
          <span className="font-display text-xl font-bold tracking-wide text-indigo">SHINENI</span>
          <span className="font-display text-[10px] font-semibold tracking-[0.35em] text-gold">INDIA</span>
        </div>
        <h1 className="mt-4 font-display text-2xl font-semibold text-indigo">Admin login</h1>
        <p className="mt-1 text-xs text-muted-foreground">Authorised personnel only.</p>
        <div className="mt-8 space-y-5">
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-foreground/70" htmlFor="admin-email">Email</label>
            <input id="admin-email" data-testid="admin-email-input" type="email" required className={inputCls}
              value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
          </div>
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-foreground/70" htmlFor="admin-password">Password</label>
            <input id="admin-password" data-testid="admin-password-input" type="password" required className={inputCls}
              value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
          </div>
        </div>
        <button type="submit" disabled={busy} data-testid="admin-login-submit"
          className="mt-8 w-full rounded-sm bg-indigo px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-indigo-deep disabled:opacity-60">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
